import { Box, SystemProps } from '@chakra-ui/react'

import EditPhotoModal from './EditPhotoModal/EditPhotoModal'
import PhotoUploadTrigger from './PhotoUploadTrigger/PhotoUploadTrigger'
import usePhotoUpload, { UsePhotoUploadProps } from './usePhotoUpload'

type PhotoUploadProps = {
  cropShape?: 'rect' | 'round'
  aspectRatio?: number
  secondCutWidth?: number
  modalTitle?: string
  modalSubtitle?: string
  children: React.ReactNode | React.ReactNode[]
} & UsePhotoUploadProps

const PhotoUpload = ({
  children,
  assetId = async (asset: { id: number }) => asset.id,
  assetType,
  saveBeforeUpload,
  failCleanup,
  width,
  height,
  onFileUploaded,
  skipCrop,
  cropShape,
  aspectRatio,
  secondCutWidth,
  modalTitle,
  modalSubtitle,
  ...props
}: PhotoUploadProps & SystemProps) => {
  const { toCrop, isOpen, isSaving, onChangeFile, onEditPhoto, setIsOpen } =
    usePhotoUpload({
      assetId,
      assetType,
      saveBeforeUpload,
      failCleanup,
      width,
      height,
      onFileUploaded,
      skipCrop,
    })

  return (
    <>
      <Box position="relative" {...props}>
        {children}
        <PhotoUploadTrigger onChangeFile={onChangeFile} disabled={isSaving} />
      </Box>

      <EditPhotoModal
        isOpen={isOpen}
        onSave={onEditPhoto}
        onClose={() => setIsOpen(false)}
        imageUrl={toCrop}
        loading={isSaving}
        cropShape={cropShape}
        aspectRatio={aspectRatio}
        secondCutWidth={secondCutWidth}
        title={modalTitle}
        subtitle={modalSubtitle}
      />
    </>
  )
}

export default PhotoUpload
